var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { customElement } from 'lit/decorators.js';
let ProgressComponent = class ProgressComponent extends GGOBaseComponent {
    static get styles() {
        return [
            ...super.styles,
            css `
        .ggo-progress-container {
          position: fixed;
          top: 10px;
          right: 10px;
        }
      `,
        ];
    }
    render() {
        return html `
      <div class="slds-notify slds-notify_alert" role="alert">
        <span class="slds-assistive-text">info</span>
        <span class="slds-icon_container slds-icon-utility-user slds-m-right_x-small" title="Description of icon when needed">
          <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
            <use xlink:href="./assets/icons/utility-sprite/svg/symbols.svg#user"></use>
          </svg>
        </span>
        <h2>
          <slot></slot>
        </h2>
        <div class="slds-notify__close">
          <button class="slds-button slds-button_icon slds-button_icon-small slds-button_icon-inverse" title="Close">
            <svg class="slds-button__icon" aria-hidden="true">
              <use xlink:href="./assets/icons/utility-sprite/svg/symbols.svg#close"></use>
            </svg>
            <span class="slds-assistive-text">Close</span>
          </button>
        </div>
      </div>
    `;
    }
};
ProgressComponent = __decorate([
    customElement('ggo-progress')
], ProgressComponent);
export { ProgressComponent };
